export enum ViewType {
  RETAILER,
  RETAILER_AND_STORE_CONFIG,
  STORE_CONFIG,
}
